const SubAbasPdps = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/produtosdaf/pdps/ficha/${id}/dadosgerais`,
  },
];

export default SubAbasPdps;
